import React, { memo, useState, forwardRef } from 'react';

import Input, { InputProps } from 'components/form/Input';

export type PasswordProps = InputProps;

export const Password = memo(
  forwardRef<HTMLInputElement, PasswordProps>((props, ref) => {
    const [visibilityOn, setVisibility] = useState(false);

    return (
      <Input
        {...props}
        ref={ref}
        type={visibilityOn ? 'text' : 'password'}
        endIcon={visibilityOn ? 'eye-open' : 'eye-close'}
        onEndIconClick={() => setVisibility(!visibilityOn)}
        endIconSize="large"
      />
    );
  })
);

Password.displayName = 'Password';
